<template>
  <div class="text-banner">
    <div class="grid grid--container">
      <div class="row row--lg-h-center">
        <div :class="`col ${columns}`">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: String,
      default: 'col--lg-8 col--md-10',
    },
  },
};
</script>

<style lang="scss" scoped>
.text-banner {
  background: var(--g-color-dark-green);
  color: #fff;
  overflow: hidden;

  .grid {
    padding-bottom: 2rem;
    padding-top: 3rem;
  }

  h1 {
    margin: 0 0 0.625rem;
  }

  p {
    margin: 0;
  }
}
</style>
